import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import  {GET, POST, PUT, DELETE}  from '../../services/api';

// Define the async thunk for the GET request
export const addSubscriptionFun = createAsyncThunk('data/add/subscription', async (data, { rejectWithValue }) => {

  try {
    const response = await POST(`/admin/subscription`, data);
    if (response?.status === 200) {
      return response.data.result; // Assuming the response is in data property
    } else {
      return rejectWithValue(response?.data || "Something went wrong");
    }
  } catch (error) {
    return rejectWithValue(error?.response?.data || "Failed to fetch data");
  }

}

);

export const listSubscriptionFun = createAsyncThunk(
    "data/list/subscription",
    async (params={}, { rejectWithValue }) => {
      try {
        const response = await GET("/admin/subscription", {...params});
        
  
        if (response?.status === 200) {
          return response.data; // Assuming response contains `data.result`
        } else {
          return rejectWithValue(response?.data || "Something went wrong");
        }
      } catch (error) {
        return rejectWithValue(error?.response?.data || "Failed to fetch data");
      }
    }
  );


  export const updateSubscriptionFun = createAsyncThunk(
    "data/update/subscription",
    async ({ id, data }, { rejectWithValue }) => {
      try {
        const response = await PUT(`/admin/subscription?subscription_id=${id}`, data);
        if (response?.status === 200) {
          return response.data.result; // Assuming response contains `data.result`
        } else {
          return rejectWithValue(response?.data || "Something went wrong");
        }
      } catch (error) {
        return rejectWithValue(error?.response?.data || "Failed to update data");
      }
    }
  );


  export const deleteSubscriptionFun = createAsyncThunk(
    "data/delete/subscription",
    async (id, { rejectWithValue }) => {
      try {
        const response = await DELETE(`/admin/subscription`, { subscription_id: id });
        if (response?.status === 200) {
          return response.data.result; // Assuming response contains `data.result`
        } else {
          return rejectWithValue(response?.data || "Something went wrong");
        }
      } catch (error) {
        return rejectWithValue(error?.response?.data || "Failed to delete data");
      }
    }
  );







const SubscriptionSlice = createSlice({
  name: 'subscription',
  initialState: {
    addSubscription: [],
    addSubLoading: false,
    AddSubError: null,
    listSubscription: [],
    listSubscriptionCount: [],
    listSubLoading: false,
    listSubError: null,
    updateSubscription: [],
    updateSubLoading: false,
    updateSubError: null,
    deleteSubscription: [],
    deleteSubLoading: false,
    deleteSubError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addSubscriptionFun.pending, (state) => {
        state.addSubLoading = true;
        state.AddSubError = null;
      })
      .addCase(addSubscriptionFun.fulfilled, (state, action) => {
        state.addSubLoading = false;
        state.addSubscription = action.result;
      })
      .addCase(addSubscriptionFun.rejected, (state, action) => {
        state.addSubLoading = false;
        state.AddSubError = action.error.message;
      });

      builder
      .addCase(listSubscriptionFun.pending, (state) => {
        state.listSubLoading = true;
        state.listSubError = null;
      })
      .addCase(listSubscriptionFun.fulfilled, (state, action) => {
        
        state.listSubLoading = false;
        state.listSubscription = action.payload.result?.rows;
        state.listSubscriptionCount = action.payload.result?.count;
      })
      .addCase(listSubscriptionFun.rejected, (state, action) => {
        state.listSubLoading = false;
        state.listSubError = action.error.message;
      });

      builder
      .addCase(updateSubscriptionFun.pending, (state) => {
        state.updateSubLoading = true;
        state.updateSubError = null;
      })
      .addCase(updateSubscriptionFun.fulfilled, (state, action) => {
        
        state.updateSubLoading = false;
        state.updateSubscription = action.payload;
      })
      .addCase(updateSubscriptionFun.rejected, (state, action) => {
        state.updateSubLoading = false;
        state.updateSubError = action.error.message;
      });

      builder
      .addCase(deleteSubscriptionFun.pending, (state) => {
        state.deleteSubLoading = true;
        state.deleteSubError = null;
      })
      .addCase(deleteSubscriptionFun.fulfilled, (state, action) => {
        
        state.deleteSubLoading = false;
        state.deleteSubscription = action.payload;
      })
      .addCase(deleteSubscriptionFun.rejected, (state, action) => {
        state.deleteSubLoading = false;
        state.deleteSubError = action.error.message;
      });
  },
});

export default SubscriptionSlice.reducer;
